export enum LibraryType {
    RISKS = 'risks',
    OPPORTUNITIES = 'opportunities',
    TASKS = 'tasks'
}
